export const menu = {
  input: {
    media: {
      label: 'Аудиофайл IVR'
    },

    wrong: {
      label: 'Невалидный выбор'
    },

    select_file: 'Выбрать файл | Выбрать файлы',

    timeout: {
      label: 'Время ожидания ответа'
    },

    action: {
      label: 'Действие при нажатии'
    }
  },

  state: {
    init: {
      description:
        'IVR - это интерактивное голосовое меню, которое направляет клиента на нужный ему отдел или оператора после того, как он нажмет соответствующую кнопку на своем телефоне.'
    }
  }
};
